import React, { useState } from 'react';
import { LuMail, LuCheck, LuLoader } from 'react-icons/lu';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../../../shared/firebase';
import dove from '../../../assets/white_dove.png';

export default function Newsletter() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      await addDoc(collection(db, 'newsletter_subscribers'), {
        email: email.trim().toLowerCase(),
        subscribedAt: new Date().toISOString()
      }).catch(() => null);
      setSubmitted(true);
      setEmail('');
      setTimeout(() => setSubmitted(false), 5000);
    } catch (err) {
      console.error("Error subscribing:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="pt-1 pb-4 sm:pb-6 mt-1 sm:mt-2 bg-transparent relative z-20">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-[#842343] rounded-[24px] p-6 md:p-8 flex flex-col lg:flex-row items-center justify-between gap-6 relative overflow-hidden shadow-[0_10px_35px_rgba(132,35,67,0.22)]">
          
          {/* Left Text */}
          <div className="flex items-center gap-4 md:gap-5 relative z-10 w-full lg:w-auto">
            <div className="w-12 h-12 md:w-14 md:h-14 rounded-2xl bg-white/10 backdrop-blur-md border border-white/20 flex items-center justify-center shrink-0 shadow-inner">
              <LuMail className="w-6 h-6 md:w-7 md:h-7 text-white drop-shadow-md" />
            </div>
            <div>
              <h2 className="font-serif font-bold text-white text-xl md:text-[24px] leading-tight drop-shadow-sm mb-1">
                Stay Connected
              </h2>
              <p className="text-white/85 text-[13px] md:text-[14px] font-normal">
                Subscribe to our newsletter and get the latest diocesan updates.
              </p>
            </div>
          </div>

          {/* Form */}
          <div className="flex-1 max-w-md xl:max-w-lg w-full relative z-10">
            {submitted ? (
              <div className="bg-white/15 backdrop-blur-md border border-white/30 rounded-xl px-5 py-3 text-white flex items-center gap-3 animate-fadeIn">
                <LuCheck className="w-5 h-5 text-[#E8B86D] shrink-0" />
                <span className="text-sm font-medium">Thank you for subscribing! You will receive diocesan updates.</span>
              </div>
            ) : (
              <form 
                onSubmit={handleSubscribe}
                className="flex w-full bg-white p-1 rounded-xl shadow-[0_6px_20px_rgba(0,0,0,0.15)] group transition-all duration-300"
              >
                <input 
                  type="email" 
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email" 
                  className="w-full px-4 py-2.5 bg-transparent text-[13px] sm:text-[14px] text-[#1a1715] outline-none placeholder:text-[#9b8c86] font-medium rounded-lg"
                  required
                />
                <button 
                  type="submit" 
                  disabled={loading}
                  className="bg-[#c39b5b] hover:bg-[#b08846] text-white font-bold text-[12px] sm:text-[13px] px-6 sm:px-8 py-2.5 rounded-lg shadow-sm hover:shadow transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center gap-2"
                >
                  {loading ? <LuLoader className="w-4 h-4 animate-spin text-white" /> : "Subscribe"}
                </button>
              </form>
            )}
          </div>
          
          {/* Decorative White Dove on the Right */}
          <div className="absolute right-0 md:right-2 bottom-0 top-0 w-44 md:w-56 pointer-events-none opacity-85 hidden sm:flex items-center justify-end">
            <img 
              src={dove} 
              alt="White Dove" 
              className="w-36 md:w-48 lg:w-52 h-auto object-contain transform translate-x-2 translate-y-1 drop-shadow-md" 
            />
          </div>

        </div>
      </div>
    </section>
  );
}
